import React, { FC, HTMLProps } from 'react';
import styles from './DashedWrapper.module.scss';

const DashedWrapper: FC<HTMLProps<HTMLDivElement>> = ({
  children,
  ...props
}: HTMLProps<HTMLDivElement>) => (
  <div {...props}>
    <div className={styles.wrapper}>
      <svg
        width="100%"
        height="100%"
        style={{ zIndex: 1 }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="99%"
          height="99%"
          opacity="0.5"
          x="0.5"
          y="0.5"
          rx="10.5"
          strokeDasharray="10 10"
        />
      </svg>
      <div style={{ zIndex: 2, position: 'relative' }}>{children}</div>
    </div>
  </div>
);

export default DashedWrapper;
